import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 4l-5 8l5 8","key":"svg-0"}],["path",{"d":"M16 4l5 8l-5 8","key":"svg-1"}]]

/**
 * IconBracketsAngle
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYnJhY2tldHMtYW5nbGUiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTggNGwtNSA4bDUgOCIgLz4KICA8cGF0aCBkPSJNMTYgNGw1IDhsLTUgOCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/brackets-angle
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBracketsAngle = createReactComponent('outline', 'brackets-angle', 'BracketsAngle', __iconNode);

export default IconBracketsAngle;